import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import PlacedOrders from './components/PlacedOrders';

const placedOrders = (props,{ t }) => (
  <Container>
    <PlacedOrders {...props} />
  </Container>
);

placedOrders.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(placedOrders);
